module.exports = __webpack_public_path__ + "static/img/pc_pd_v2_2.1f3b93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v2_2.png
// module id = ZFLH
// module chunks = 0